<template>
  <TheQuestion v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        style="margin: 5px;"
        shape="round"
        type="primary"
        class="fl-right"
        @click="$router.push('/question/create')"
        icon="plus"
      >문의하기</a-button>
    </template>
    <ul class="accordion-type2" v-if="$store.state.question.questions.length > 0">
      <QuestionCard
        v-for="(question, index) in $store.state.question.questions"
        :isOpen="$route.params.idx === question.idx"
        :key="index"
        :idx="question.idx"
        :title="question.title"
        :author="question.author"
        :answer="question.answer"
        :contents="question.contents"
        :uploadAt="$moment(question.uploadAt)"
        :reads="question.reads"
      />
    </ul>
    <div class="card-empty" v-else>
      <i class="no-content-logo"></i>
      <p>아직 질문이 없습니다.</p>
    </div>
  </TheQuestion>
</template>
<script>
import TheQuestion from "@/components/Question/TheQuestion";
import QuestionCard from "../../components/Question/QuestionCard";
import { mapActions } from "vuex";

export default {
  name: "QuestionStatus",
  components: { TheQuestion, QuestionCard },
  methods: mapActions(["refreshQuestion"]),
  mounted() {
    this.refreshQuestion();
  }
};
</script>
